import type { GrantPublic, UserPublic } from '@accounts/shared';

import { STR } from '../i18n';

import { formatDate } from './format';

/**
 * IDENTITY IS A FOREIGN KEY. `grantedBy` is an id, so the granter's NAME is resolved by
 * looking that id up in the users we already loaded — never by storing or trusting a label
 * on the grant. An id with no match (the operator CLI has no user behind it) simply drops
 * the attribution rather than inventing one.
 */
export function namesById(users: readonly UserPublic[]): Map<string, string> {
  return new Map(users.map((user) => [user.id, user.name]));
}

export function grantedLine(grant: GrantPublic, names: Map<string, string>): string {
  const by = names.get(grant.grantedBy);
  const on = formatDate(grant.grantedAt);
  return by === undefined ? STR.grants.grantedOn(on) : STR.grants.grantedBy(on, by);
}

export function revokedLine(grant: GrantPublic): string {
  return STR.grants.revokedLine(formatDate(grant.revokedAt));
}
